import { Link } from "react-router-dom"
import styled from "styled-components"
import colors from "../../utils/style/colors.tsx"
import Logo from "../../assets/images/logo-footer.png"
import FormContact from "../../components/FormContact/FormContact.jsx"
import { Transition } from "../../utils/style/transition.tsx"

const HomeLogo = styled.img`
    height: auto;
    width: 35%;
    cursor: pointer;

    @media (max-width: 1000px) {
        width: 27%;
    }
`

const FooterContainer = styled.footer`
    padding: 2% 5%;
    display: flex;
    justify-content: space-between;
    align-items: start;
    background: ${colors.light_pink};

    @media (max-width: 1150px) {
        padding: 2% 2%;
    }

    @media (max-width: 1000px) {
        flex-direction: column-reverse;
    }
`

const LeftPart = styled.div`
    display: flex;
    align-items: center;
    width: 40%;
    height: auto;
    flex-direction: column;
    padding-top: 20px;

    @media (max-width: 1000px) {
        width: 70%;
        margin: 0;
        align-self: center;
        padding-bottom: 3%;
    }
`

const LogoContainer = styled.div`
    width: 100%;
    height: auto;
    text-align: center;
    margin-bottom: 20px;
`

const RightPart = styled.div`
    display: flex;
    align-items: start;
    width: 60%;
    justify-content: space-evenly;
    height: auto;
    margin-left: 10%;

    @media (max-width: 1150px) {
        margin-left: 5%;
    }

    @media (max-width: 1000px) {
        width: 95%;
        padding: 5% 0%;
        margin: 0;
        align-self: center;
    }
`

const InformationWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 80px;

    @media (max-width: 1000px) {
        width: 110%;
        justify-content: space-between;
        gap: 0;
    }
   
`

const InformationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    text-align: start;
    height: fit-content;
`

const TitleColonne = styled.h3`
    font-family: "Archivo", sans-serif;
    margin: 0;
    padding: 0;
    color: ${colors.dark_red};
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        font-size: 18px;
        text-align: center;
    }
`

const BottomPart = styled.div`
    background-color: ${colors.light_pink};
    display: flex;
    justify-content: center;
    font-size: 20px;

    p {
        color: #252525;
        padding: 1%;
        margin: 0;
    }

    @media (max-width: 768px) {
        font-size: 12px;
    }
`

const MentionsLegalesLink = styled.p`
    font-family: "Archivo", sans-serif;
    color: ${colors.black};
    text-decoration: none;
    align-self: center;
    opacity: 1;
    font-size: 16px;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`

const TextInfo = styled.p`
    font-family: "Archivo", sans-serif;
    color: ${colors.black};
    text-decoration: none;
    align-self: center;
    font-size: 18px;
    margin: 0;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        text-align: center;
        font-size: 16px;
    }
`

const FooterStyledLinkExterieur = styled(Link)`
    font-family: "Archivo", sans-serif;
    color: ${colors.black};
    text-decoration: none;
    align-self: center;
    font-size: 18px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        text-align: center;
        font-size: 16px;
    }
`

const linkScroll = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    })
}

function Footer() {
    return (
        <>
            <Transition theme={"rose"} orientation={"180deg"} />
            <FooterContainer id="contact">
                <LeftPart>
                    <LogoContainer>
                        <HomeLogo src={Logo} alt="" onClick={linkScroll} />
                    </LogoContainer>
                    <InformationWrapper>
                        <InformationContainer>
                            <TitleColonne>Mes services</TitleColonne>
                            <TextInfo>Logos</TextInfo>
                            <TextInfo>Cartes de visites</TextInfo>
                            <TextInfo>Flyers et dépliants</TextInfo>
                            <TextInfo>Sites web</TextInfo>
                        </InformationContainer>
                        <InformationContainer>
                            <TitleColonne>Réseaux</TitleColonne>
                            <FooterStyledLinkExterieur
                                to="https://www.linkedin.com/in/leo-langlois/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Linkedin
                            </FooterStyledLinkExterieur>

                            <FooterStyledLinkExterieur
                                to="https://github.com/leoLgls/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Github
                            </FooterStyledLinkExterieur>
                        </InformationContainer>
                    </InformationWrapper>
                </LeftPart>

                <RightPart id="contact">
                    <FormContact />
                </RightPart>
            </FooterContainer>

            <BottomPart>
                <MentionsLegalesLink>
                    © 2024 Léo Langlois - CLIP Web
                </MentionsLegalesLink>
            </BottomPart>
        </>
    )
}

export default Footer
